import {IAppTypeMap, IBounds, Ic, IEntityAlert, ILedInfo, IProjectTypeSelector} from '../models/common';
import {MainViewType, SortDirectionType} from '../models/view';
import {Feature, FeatureEx} from "../models/features/features";
import {IUserSpec} from "../models/ISpec";
import {Validator, ValidatorCreator} from "../models/validator/IValidator";
import {Acceptor, AcceptorCreator} from "../models/acceptor/IAcceptor";
import {Comparator, IComparator} from "../models/IComparator";
import {UpdateDesign, UpdateDesignCreator} from "../models/IUpdateDesign";
import {SPEC_STATE_INIT} from "../models/Spec_States";
import {EMPTY_ENTITY_ALERT} from "../models/EntityAlert";
import {IeDsFileSystem, IeDsFolder, IUserInfo} from "../models/user-info";

export const APP_PROJECTTYPES_STATE_INIT: IAppProjectType = {
  rootMenu: [],
  breadcrumb: [],
  error: '',
  appTypeMap: null,
  error_appTypeMap: ''
};

export interface IAppProjectType {
  rootMenu: IProjectTypeSelector[];
  breadcrumb: IProjectTypeSelector[];
  error: string;
  appTypeMap: IAppTypeMap;
  error_appTypeMap: string;
}

export const APP_TOOLBAR_STATE_INIT: IAppToolBar = {
  viewType: MainViewType.GRID, sortField: 'Default', direction: SortDirectionType.DESCEND, search: '', sideBarOpened: false
};

export interface IAppToolBar {
  viewType: MainViewType;
  sortField: string;
  direction: SortDirectionType;
  search: string;
  sideBarOpened: boolean;
}

export const APP_USER_INFO_STATE_INIT: IAppUserInfo = {
  loadUserData: 'none',
  userProjects: null,
  exampleProjects: null,
  currentUserFolder: [],
  currentExampleFolder: [],
  user: null
};

export interface IAppUserInfo {
  loadUserData: string;
  userProjects: IeDsFileSystem;
  exampleProjects: IeDsFileSystem;
  currentUserFolder: IeDsFolder[];         // array that represent current user path folder
  currentExampleFolder: IeDsFolder[];      // array that represent current example path folder
  user: IUserInfo;
}


export const APP_FACTORY_SERVICE_STATE_INIT = {
  acceptorCreator: Acceptor.createAcceptor,
  updateDesignCreator: UpdateDesign.createUpdateDesign,
  comparator: new Comparator() as IComparator,
  validatorCreator: Validator.createValidator,
  stdFeatures: []
};

export interface IAppFactoryService {
  acceptorCreator: AcceptorCreator;
  updateDesignCreator: UpdateDesignCreator;
  comparator: IComparator;
  validatorCreator: ValidatorCreator;
  stdFeatures: Feature[];
}

export const APP_CATALOG_STATE_INIT: IAppCatalog = {
  name: '', appClass: '', topologiesFilter: [],
  db: [], designSolutions: [], ledDB: null,
  loading: false,
  loadComplete: false,
  unableToFindSolution: false,
  selectedSolution: null,
  error: '',
  service: APP_FACTORY_SERVICE_STATE_INIT,
};

export interface IAppCatalog {
  name: string;
  appClass: string;
  topologiesFilter: string[];
  db: Ic[];
  designSolutions: Ic[];
  ledDB: ILedInfo[];
  selectedSolution: Ic;
  loading: boolean;
  loadComplete: boolean;
  unableToFindSolution: boolean;
  error: string;
  service: IAppFactoryService;
}

export const APP_SPEC_STATE_INIT: IAppSpec = {
  noteGlobal: EMPTY_ENTITY_ALERT,
  featuresFilter: [],
  spec: SPEC_STATE_INIT,
  outputBounds: {min: 1, max: 6},
  specEdited: false
};

export interface IAppSpec {
  spec: IUserSpec;
  featuresFilter: FeatureEx[];
  noteGlobal: IEntityAlert;
  outputBounds: IBounds;
  specEdited: boolean;
}

export const APP_CONTEXT_STATE_INIT: IAppContext = {context: null, frameMode: false};

export interface IAppContext {
  context: any;
  frameMode: boolean;
}

export const APP_CONFIG_STATE_INIT: IAppConfig = {
  AuthIDP: 'st-idp',
  AuthRegion: 'eu-west-1',
  AuthUrl: 'https://eds-qa.auth.eu-west-1.amazoncognito.com',
  ClientID: '3mrrli3o1hmmnutscjeth8u2g1',
  edsService: '/',
  edsLogStromboli: false,
  edsAddScript: false,
};


export interface IAppConfig {
  AuthIDP: string;
  AuthRegion: string;
  AuthUrl: string;
  ClientID: string;
  edsService: string;
  edsLogStromboli: boolean;
  edsAddScript: boolean;
}

export const SELECTOR_STATE_INIT: ISelectorState = {
  appProjectTypes: APP_PROJECTTYPES_STATE_INIT,
  appToolBar: APP_TOOLBAR_STATE_INIT,
  appCatalog: APP_CATALOG_STATE_INIT,
  appSpec: APP_SPEC_STATE_INIT,
  appUserInfo: APP_USER_INFO_STATE_INIT,
  appContext: APP_CONTEXT_STATE_INIT,
  appConfig: APP_CONFIG_STATE_INIT,
  router: null
};

export interface ISelectorState {
  appProjectTypes: IAppProjectType;
  appToolBar: IAppToolBar;
  appCatalog: IAppCatalog;
  appSpec: IAppSpec;
  appUserInfo: IAppUserInfo;
  appContext: IAppContext;
  appConfig: IAppConfig;
  router: any;
}
